// extracted by mini-css-extract-plugin
export default {"widget":"TextSwitcher_widget__d7yX5","item":"TextSwitcher_item__E+ajD","active":"TextSwitcher_active__X7I02"};